/* eslint-disable no-loop-func */
import { useEffect, useRef } from "react";
import worker_script from "../worker";
import { useAppDispatch } from "../store/storeRequests";
import { logoutUser } from "../store/authentication/authentication.actions";
import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import { showMessageOnFailure } from "../store/error.actions";

const events = ["load", "mousemove", "mousedown", "scroll", "keypress", "click"];

let worker: null | Worker = null

const useIdleTimout = () => {
    

    const isWorkerInitialized = useRef(false)
    const currentUser = useAuth()
    const navigate = useNavigate()

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (isWorkerInitialized.current) return
        
        if (currentUser === 1) {

            if (worker === null) {
                worker = new Worker(worker_script)
            }
            worker.postMessage('start')
        }
        
    }, [currentUser])

    if (worker !== null) {
        worker.onmessage = async(ev) => {

            if (ev.data === 'expired') {
                await dispatch(logoutUser())
                navigate('/')
                dispatch(showMessageOnFailure('Session expired. Please login again...'))
            }
            
            if (ev.data === 'initialized') {
                for (let i in events) {
                    document.addEventListener(events[i], () => {
                        if (worker !== null) worker.postMessage('reset')
                    });
                }
                isWorkerInitialized.current = true
            }
            
            if (ev.data === 'terminated') {
                isWorkerInitialized.current = false
                navigate('/')
                for (let i in events) {
                    document.removeEventListener(events[i], () => {
                        if (worker !== null) worker.postMessage('terminate')
                    });
                }
                if (worker !== null) worker.terminate()
                worker = null
            }
        }
    }


    return worker
};

export default useIdleTimout;
